import type { SidebarItem } from '@vk-workspace/superapp-sdk/navigation';
import { getFeature, isFeature } from 'Cloud/Application/FeaturesEs6';
import { IS_MY_TEAM, IS_ONPREMISE, IS_PHONE_BROWSER, IS_VKT_DESKTOP, IS_VKT_WEBVIEW } from 'reactApp/appHelpers/configHelpers';

/** CLOUDWEB-20701  Интеграция новой навигации слева, первая стадия */
export const LEFTNAV_ENABLED =
    !IS_MY_TEAM && !IS_ONPREMISE && !IS_PHONE_BROWSER && !IS_VKT_DESKTOP && !IS_VKT_WEBVIEW && isFeature('left-nav');

export const LEFT_NAV_VERSION = getFeature('left-nav-version') || '1.2.1';

/** CLOUDWEB-20846: Имя nocode промо для онбординга */
export const LEFT_NAV_ONBORDING_PROMO_NAME = getFeature('left-nav-onboarding-promo-name') || 'cloudweb-20846';

const menuCfgOverride = (getFeature('left-nav-cfg-override') || []) as SidebarItem[];

export const menuConfig: SidebarItem[] = (getFeature('left-nav-cfg') as SidebarItem[]) || [
    {
        id: 'mail',
        iconType: 'mail',
        name: { ru: 'Почта', en: 'Email' },
        type: 'linkTab',
        href: 'https://e.mail.ru/inbox/',
    },
    {
        id: 'cloud',
        iconType: 'cloud',
        name: { ru: 'Облако', en: 'Cloud' },
        type: 'linkTab',
        href: 'https://cloud.mail.ru/home/',
    },
    {
        id: 'documents',
        iconType: 'documents',
        name: { ru: 'Документы', en: 'Documents' },
        type: 'linkTab',
        href: 'https://doc.mail.ru/document',
    },
    {
        id: 'calendar',
        iconType: 'calendar',
        name: { ru: 'Календарь', en: 'Calendar' },
        type: 'linkTab',
        href: 'https://calendar.mail.ru/',
    },
    {
        id: 'calls',
        iconType: 'calls',
        name: { ru: 'Звонки', en: 'Calls' },
        type: 'linkTab',
        href: 'https://e.mail.ru/calls/',
    },
    // {
    //     id: 'notes',
    //     iconType: 'notes',
    //     name: 'Заметки',
    //     type: 'linkTab',
    //     newTab: true,
    //     href: 'https://notes.mail.ru/',
    // },
    // {
    //     id: 'tasks',
    //     iconType: 'tasks',
    //     name: 'Задачи',
    //     type: 'linkTab',
    //     newTab: true,
    //     href: 'https://todo.mail.ru/inbox',
    // },
    // {
    //     id: 'board',
    //     iconType: 'board',
    //     name: 'Доска',
    //     type: 'linkTab',
    //     newTab: true,
    //     href: 'https://board.vk.ru',
    // },
    { id: 'main', iconType: 'home', name: { ru: 'Главная', en: 'Home' }, type: 'linkTab', newTab: true, href: 'https://mail.ru' },
    {
        id: 'mailspace',
        iconType: 'mailspace',
        name: { ru: 'Mail Space', en: 'Mail Space' },
        type: 'linkTab',
        showDivider: true,
        href: 'https://cloud.mail.ru/promo/quota',
        promo: {
            urlLight: 'https://imgs2.imgsmail.ru/static/navigation/tariffPromo/counter_light.png',
            urlDark: 'https://imgs2.imgsmail.ru/static/navigation/tariffPromo/counter_dark.png',
        },
    },
];

try {
    menuCfgOverride.forEach((itemOverride) => {
        const idx = menuConfig.findIndex((t) => t.id === itemOverride.id);

        if (idx < 0) {
            menuConfig.push(itemOverride);
        } else {
            menuConfig[idx] = {
                ...menuConfig[idx],
                ...itemOverride,
            };
        }
    });
} catch {}
